import {Action, configureStore, ThunkAction} from '@reduxjs/toolkit';
import yogaReducer from '../features/yoga/yogaSlice';
import {yogaInitialState} from '../features/yoga/yogaSlice';
import {loadFromLocalStorage} from "../features/storage/localStorage";

export const store = configureStore({
  reducer: {
    yoga: yogaReducer,
  },
  preloadedState: mergeStates()
});

function mergeStates(){
  const savedState =loadFromLocalStorage()
  return {yoga:{...yogaInitialState, ...savedState}}
}

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
